<script setup lang="ts" name="TabBar">
import { ref, computed, defineProps, defineEmits } from 'vue';
import {useRoute} from "vue-router";
import { setSession } from '/@/kernel-mn/utils/storage';
import { useUserStore } from '/@/kernel-mn/stores/user';
import { tResLoc } from '/@/plugins/global';
interface tabProps {
  data?: [
    {
      title: string;
      to: string;
      name: string;
      icon: string;
      iconActive: string;
      isOpen?: boolean,
      issvg?: boolean,
    }
  ];
}

const props = defineProps<tabProps>();
// 选中标签 和 选中标签之前的事件
const emit = defineEmits(['chang', 'beforeChange']);
const userStore = useUserStore()
const route:any = useRoute();
const active = ref(props.data.find(item => item.name === route.name?.toLowerCase())?.name || 'home');

const special = computed(()=>{
  return ['themeKYMN'].includes(tResLoc().value) && props.data.some(v => v.name === 'game')
})

const onChange = value => {
  setSession('lotteryTabIndex', '')
  emit('chang', value);
};
const beforeChange = value => {
  if (userStore.isLogined && userStore.isTryLogined && ['recharge', 'sport', 'mine'].includes(value)) {
        userStore.setTryLoinInfo({ show: true, type: 2 })
        return  false
  }
  let currentItem:any = props.data.find(item => item.name === value) || {};
  if (currentItem.isOpen === false) {
    emit('beforeChange', currentItem)
    return false;
  } else {
    return true;
  }
};
</script>

<template>
  <van-tabbar v-if="special" class="footer-main special" :fixed="false" route v-model="active"
    :before-change="beforeChange" @change="onChange">
    <template v-for="(item, index) in props.data" :key="index">
      <van-tabbar-item v-if="index != 2" :to="item.to" :name="item.name">
        <span class="item-text fz-13" :active="active" v-text="item.title"></span>
        <template #icon="props">
          <template v-if="item.issvg">
            <i class="svg-icon" :style="`--url: url('${props.active? item.iconActive: item.icon}')`"></i>
          </template>
          <img v-else class="img-icon spe" :src="props.active? item.iconActive: item.icon" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item v-else :to="item.to" :name="item.name">
        <template #icon="props">
          <!-- <img class="img-icon none" src="/images/themeKYMN/tabbar/ty1.png" /> -->
        </template>
      </van-tabbar-item>
    </template>
  </van-tabbar>
  <van-tabbar v-else class="footer-main" :fixed="false" route v-model="active" :before-change="beforeChange"
    @change="onChange">
    <template v-for="(item, index) in props.data" :key="index">
      <van-tabbar-item :to="item.to" :name="item.name">
        <span class="item-text fz-13" :active="active" v-text="item.title"></span>
        <template #icon="props">
          <template v-if="item.issvg">
            <i class="svg-icon" :style="`--url: url('${props.active? item.iconActive: item.icon}')`"></i>
          </template>
          <img v-else class="img-icon" :src="props.active? item.iconActive: item.icon" />
        </template>
      </van-tabbar-item>
    </template>
  </van-tabbar>
</template>

<style lang="scss" scoped>
.footer-main {
  padding-top: px2rem(10);
  top: px2rem(-10);
  left: 0;
  position: relative;
  height: 100%;
  background: transparent var(--tabbar-bg) 0 0 / 100% 100% no-repeat;
  &:after {
    display: none;
  }
  :deep(.van-tabbar-item) {
    white-space: nowrap;
    overflow: hidden;
    max-width: 50%;
    color: var(--tabbar-text-color);
    .van-tabbar-item__icon {
      font-size: px2rem(14);margin-bottom: 0;
    }
    .img-icon, .svg-icon {
      height: var(--tabbar-icon-height);
      width: var(--tabbar-icon-height);
    }
    .img-icon.none{
      // opacity: 0;
      // display: none;
    }
    .img-icon.spe{
      padding-top: px2rem(20);
    }
    .van-tabbar-item__text {
      width: 100%;
      text-align: center;
    }
    &.van-tabbar-item--active {
      background: none;
      color: var(--tabbar-text-active-color);
    }
  }
  .svg-icon {
    @include bgSvg(0,0,0, var(--url), 0);
  }
  .item-text {
    display: block;@include text-overflow();width: 95%;margin: 0 auto;line-height: 1.3;
  }
}
.themeKYMN {
  .footer-main {
    background: var(--tabbar-bg-img) no-repeat center;
    background-size: cover;
    // background-color: rgba(0, 0, 0, 0.03);
    // background-color: rgba(255, 255, 255, 0.01);
    // :deep(.van-tabbar-item--active) {
    //   background: linear-gradient(180deg, #FEEDE7, #fff);
    // }
  }
}
</style>
